module.exports = __webpack_public_path__ + "img/hz_10.5512a85d.jpg";